<template>
  <SOSlotBase container-name="container-edit-mesin">
    <template v-slot:title-bar>
      <SOTitleBar type="back" page-title="Ubah Mesin" @back="back" />
    </template>
    <template v-slot:content v-if="!loading">
      <div class="content-wrapper f-regular f-14 d-block">
        <span class="f-c-midgrey">ID Device: </span
        ><span class="f-c-black">{{ idmesin }}</span>
      </div>
      <div class="content-wrapper">
        <div class="content-item flex-1">
          <div class="wrapper-input">
            <SOInputRegular
              title="Nama Mesin"
              :required="true"
              v-model="input.nama"
              @input="input.nama"
            />
            <ErrorMessage
              label="Nama Mesin"
              class="error"
              :validation="$v.input.nama"
            />
          </div>
          <div class="wrapper-input">
            <label class="form-label require"> Jenis Mesin </label>
            <SOInputRadioBig
              :radio-group="radioJenis"
              :radio-selected="input.jenis"
              @selected-radio="
                (val) => {
                  input.jenis = parseInt(val);
                }
              "
            />
          </div>
          <div class="wrapper-input">
            <label class="form-label require" v-if="input.jenis === 1"> Sensor Pintu </label>
            <label class="form-label require" v-if="input.jenis === 2"> Sensor Kelembapan </label>
            <SOInputRadioBig
              :radio-group="radioSensor"
              :radio-selected="input.door"
              @selected-radio="
                (val) => {
                  input.door = parseInt(val);
                }
              "
            />
          </div>
          <div class="wrapper-input">
            <SOInputSelectMultiple
              title="Kategori Mesin"
              :label="'title'"
              :track-by="'value'"
              :searchable="true"
              :taggable="true"
              :multiple="false"
              :options="tag"
              :value="kategoriMesin"
              @selected="selectedTagMesin"
            />
            <ErrorMessage
              label="Kategori Mesin"
              class="error"
              :validation="$v.input.tag"
            />
            <div class="f-c-midgrey f-12 f-regular m-t-8">
              Mesin dapat digunakan untuk layanan yang terhubung dengan kategori
              yang sama.
            </div>
          </div>
        </div>
        <div class="content-item">
          <SOButton
            :full="true"
            :primary="true"
            text="Simpan"
            @action="updateMesin"
          />
        </div>
      </div>
    </template>
    <template v-slot:skeleton>
      <SOLoadingPage v-if="loading" />
    </template>
  </SOSlotBase>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOInputRadioBig from "@/so-components/global/input/SOInputRadioBig";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import SOButton from "@/so-components/global/ui/SOButton";
import { mapGetters } from "vuex";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import ErrorMessage from "@/component-items/ErrorMessage";
import { minLength, required } from "vuelidate/lib/validators";
import SOInputSelectMultiple from "@/so-components/global/input/SOInputSelectMultiple";

export default {
  name: "SnapMesinEdit",
  components: {
    SOInputSelectMultiple,
    ErrorMessage,
    SOLoadingPage,
    SOButton,
    SOInputSelect,
    SOInputRadioBig,
    SOInputRegular,
    SOTitleBar,
    SOSlotBase,
  },
  data() {
    return {
      loading: true,
      idoutlet: "",
      idmesin: "",
      tag: [],
      kategoriMesin: [],
      input: {
        nama: "",
        jenis: 1,
        door: 1,
        tag: "",
      },
      radioJenis: [
        {
          title: "Mesin Cuci",
          name: "jenis-mesin",
          value: "1",
          id: "mc",
        },
        {
          title: "Mesin Pengering",
          name: "jenis-mesin",
          value: "2",
          id: "mp",
        },
      ],
      radioSensor: [
        {
          title: "Ada",
          name: "sensor",
          value: "1",
          id: "sa",
        },
        {
          title: "Tidak Ada",
          name: "sensor",
          value: "0",
          id: "st",
        },
      ],
    };
  },
  validations: {
    input: {
      nama: {
        required,
        minLength: minLength(2),
      },
      tag: {
        required,
      },
    },
  },
  methods: {
    back() {
      this.$router.push({
        name:
          this.$route.query.from === "list"
            ? "ListSnapMesin"
            : "SnapMesinDetail",
        query: {
          idoutlet: this.idoutlet,
          idsnap_mesin: this.idmesin,
        },
      });
    },

    async tagMesin() {
      const res = await this.$store.dispatch(
        "snapMesinModule/fetchTagMesin",
        this.idoutlet
      );
      if (res.success) {
        this.listTagMesin.data.forEach((tagmesin) => {
          this.tag = [
            ...this.tag,
            {
              id: tagmesin.id,
              title: tagmesin.nama,
              value: tagmesin.nama,
            },
          ];
        });
      } else {
        this.$toast.error(res.err);
      }
    },
    async mesinDetail() {
      let query = {
        idoutlet: this.idoutlet,
        idsnap_mesin: this.idmesin,
      };
      const res = await this.$store.dispatch(
        "snapMesinModule/fetchDetailMesin",
        query
      );
      if (res.success) {
        this.input.nama = this.detailMesin.data.nama;
        this.input.jenis = this.detailMesin.data.jenis;
        this.input.door = this.detailMesin.data.door;
        this.input.tag = this.detailMesin.data.snap_tag.nama;
        this.kategoriMesin[0] = {
          id: this.detailMesin.data.snap_tag.id,
          title: this.detailMesin.data.snap_tag.nama,
          value: this.detailMesin.data.snap_tag.nama,
        };
        this.loading = false;
      }
    },

    validateError() {
      this.$v.input.nama.$touch();
      this.$v.input.tag.$touch();
      return this.$v.input.nama.$invalid || this.$v.input.tag.$invalid;
    },

    async updateMesin() {
      if (this.kategoriMesin.title !== undefined) {
        this.input.tag = this.kategoriMesin.title;
      } else {
        this.input.tag = this.kategoriMesin[0].title;
      }
      if (this.validateError()) {
        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
        return;
      }
      let payload = {
        idoutlet: this.idoutlet,
        idsnap_mesin: this.idmesin,
        input: this.input,
      };

      const res = await this.$store.dispatch(
        "snapMesinModule/updateMesin",
        payload
      );
      if (res.success) {
        this.$toast.success(res.msg.msg);
        this.back();
      } else {
        this.$toast.error(res.msg.msg);
      }
    },
    selectedTagMesin(val) {
      this.kategoriMesin = val;
    },
  },
  async mounted() {
    this.idoutlet = this.$route.query.idoutlet;
    this.idmesin = this.$route.params.idmesin;
    await this.tagMesin();
    await this.mesinDetail();
  },
  async beforeDestroy() {
    await this.$store.commit("snapMesinModule/resetDetail");
  },
  computed: {
    ...mapGetters("snapMesinModule", {
      detailMesin: "getDetailMesin",
      listTagMesin: "getListTagMesin",
    }),
  },
};
</script>

<style scoped>
.content-wrapper {
  padding: 12px 20px;
  border-top: 1px solid #e0e0e0;
}

.content-wrapper:nth-child(2) {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  height: calc(100vh - 164px);
}

.wrapper-input:not(:nth-child(1)) {
  margin-top: 16px;
}
</style>